export const FETCH_VISITS_SUBMITTED_FOR_TYPING = "[TYPIST] FETCH_VISITS_SUBMITTED_FOR_TYPING";
export const FETCH_VISITS_SUBMITTED_FOR_TYPING_START = "[TYPIST] FETCH_VISITS_SUBMITTED_FOR_TYPING_START";
export const FETCH_VISITS_SUBMITTED_FOR_TYPING_SUCCESS = "[TYPIST] FETCH_VISITS_SUBMITTED_FOR_TYPING_SUCCESS";
export const FETCH_VISITS_SUBMITTED_FOR_TYPING_ERROR = "[TYPIST] FETCH_VISITS_SUBMITTED_FOR_TYPING_ERROR";

export const VIEW_SUBMITTED_FOR_TYPING_VISIT = "[TYPIST] VIEW_SUBMITTED_FOR_TYPING_VISIT";
export const VIEW_SUBMITTED_FOR_TYPING_VISIT_START = "[TYPIST] VIEW_SUBMITTED_FOR_TYPING_VISIT_START";
export const VIEW_SUBMITTED_FOR_TYPING_VISIT_SUCCESS = "[TYPIST] VIEW_SUBMITTED_FOR_TYPING_VISIT_SUCCESS";
export const VIEW_SUBMITTED_FOR_TYPING_VISIT_ERROR = "[TYPIST] VIEW_SUBMITTED_FOR_TYPING_VISIT_ERROR";

export const LOCK_SUBMITTED_FOR_TYPING_VISIT = "[TYPIST] LOCK_SUBMITTED_FOR_TYPING_VISIT";
export const LOCK_SUBMITTED_FOR_TYPING_VISIT_START = "[TYPIST] LOCK_SUBMITTED_FOR_TYPING_VISIT_START";
export const LOCK_SUBMITTED_FOR_TYPING_VISIT_SUCCESS = "[TYPIST] LOCK_SUBMITTED_FOR_TYPING_VISIT_SUCCESS";
export const LOCK_SUBMITTED_FOR_TYPING_VISIT_ERROR = "[TYPIST] LOCK_SUBMITTED_FOR_TYPING_VISIT_ERROR";

export const UNLOCK_SUBMITTED_FOR_TYPING_VISIT = "[TYPIST] UNLOCK_SUBMITTED_FOR_TYPING_VISIT";
export const UNLOCK_SUBMITTED_FOR_TYPING_VISIT_START = "[TYPIST] UNLOCK_SUBMITTED_FOR_TYPING_VISIT_START";
export const UNLOCK_SUBMITTED_FOR_TYPING_VISIT_SUCCESS = "[TYPIST] UNLOCK_SUBMITTED_FOR_TYPING_VISIT_SUCCESS";
export const UNLOCK_SUBMITTED_FOR_TYPING_VISIT_ERROR = "[TYPIST] UNLOCK_SUBMITTED_FOR_TYPING_VISIT_ERROR";

export const FETCH_RADIOLOGIST_TEMPLATES = "[TYPIST] FETCH_RADIOLOGIST_TEMPLATES";
export const FETCH_RADIOLOGIST_TEMPLATES_START = "[TYPIST] FETCH_RADIOLOGIST_TEMPLATES_START";
export const FETCH_RADIOLOGIST_TEMPLATES_SUCCESS = "[TYPIST] FETCH_RADIOLOGIST_TEMPLATES_SUCCESS";
export const FETCH_RADIOLOGIST_TEMPLATES_ERROR = "[TYPIST] FETCH_RADIOLOGIST_TEMPLATES_ERROR";

export const SET_FOR_TYPING_SEARCH_FILTER_AND_SORT = "[TYPIST] SET_FOR_TYPING_SEARCH_FILTER_AND_SORT";
export const SET_AUTO_NEXT_VISIT = "[TYPIST] SET_AUTO_NEXT_VISIT";

export const SET_WORKLIST_PAGINATION = "[TYPIST] SET_WORKLIST_PAGINATION"
export const RESET_FOR_TYPING_FILTER = "[TYPIST] RESET_FOR_TYPING_FILTER"

export const setForTypingSearchFilterAndSort = (searchFilter, sortConditions, skippedVisits) => {
    return {
        type: SET_FOR_TYPING_SEARCH_FILTER_AND_SORT,
        payload: {
            searchFilter,
            sortConditions,
            skippedVisits
        }
    };
}

export const getVisitsSubmittedForTyping = (payload) => {
    return {
        type: FETCH_VISITS_SUBMITTED_FOR_TYPING,
        payload
    };
};

export const viewWorklistVisit = (visit) => {
    return {
        type: VIEW_SUBMITTED_FOR_TYPING_VISIT,
        visit
    };
}

export const fetchRadiologistTemplates = (radiologistCode) => {
    return {
        type: FETCH_RADIOLOGIST_TEMPLATES,
        radiologistCode
    };
}

export const setAutoNextVisit = (autoNextVisit) => {
    return {
        type: SET_AUTO_NEXT_VISIT,
        autoNextVisit
    };
}

export const resetForTypingFilter = () => {
    return {
        type: RESET_FOR_TYPING_FILTER,
    };
}